<template>
  <div class="wechat-settings-container">
    <div class="page-header"><h2><span class="breadcrumb-level">系统管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">系统配置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">微信配置</span></h2></div>
    <el-card shadow="hover">
      <el-tabs v-model="activeTab" type="card">
        <!-- 小程序信息 -->
        <el-tab-pane label="小程序信息" name="miniprogram">
          <el-form
            ref="miniProgramFormRef"
            :model="miniProgramForm"
            :rules="miniProgramRules"
            label-position="top"
            label-width="140px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="AppID（小程序ID）" prop="wechat_mini_program_appid">
                  <el-input v-model="miniProgramForm.wechat_mini_program_appid" placeholder="请输入小程序AppID" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="AppSecret（小程序密钥）" prop="wechat_mini_program_secret">
                  <el-input v-model="miniProgramForm.wechat_mini_program_secret" type="password" show-password placeholder="请输入小程序AppSecret" />
                </el-form-item>
              </el-col>
            </el-row>

            <div class="form-actions">
              <el-button @click="handleMiniProgramReset">重置</el-button>
              <el-button type="primary" @click="handleMiniProgramSave">保存设置</el-button>
            </div>
          </el-form>
        </el-tab-pane>

        <!-- 微信商户号信息 -->
        <el-tab-pane label="微信商户号信息" name="merchant">
          <el-form
            ref="merchantFormRef"
            :model="merchantForm"
            :rules="merchantRules"
            label-position="top"
            label-width="140px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="商户号" prop="wechat_merchant_id">
                  <el-input v-model="merchantForm.wechat_merchant_id" placeholder="请输入微信商户号" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商户名称" prop="wechat_merchant_name">
                  <el-input v-model="merchantForm.wechat_merchant_name" placeholder="请输入商户名称" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="商户操作密码" prop="wechat_merchant_password">
                  <el-input v-model="merchantForm.wechat_merchant_password" type="password" show-password placeholder="请输入商户操作密码" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="APIv2 密钥" prop="wechat_api_v2_key">
                  <el-input v-model="merchantForm.wechat_api_v2_key" placeholder="请输入APIv2密钥" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="APIv3 密钥" prop="wechat_api_v3_key">
                  <el-input v-model="merchantForm.wechat_api_v3_key" placeholder="请输入APIv3密钥" />
                </el-form-item>
              </el-col>
            </el-row>


            <div class="form-actions">
              <el-button @click="handleMerchantReset">重置</el-button>
              <el-button type="primary" @click="handleMerchantSave">保存设置</el-button>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getWechatSettings, saveWechatSettings } from '@/api/wechat';

export default {
  name: 'WechatSettings',
  setup() {
    const activeTab = ref('miniprogram');
    const miniProgramFormRef = ref(null);
    const merchantFormRef = ref(null);

    // 小程序信息表单
    const miniProgramForm = reactive({
      wechat_mini_program_appid: '',
      wechat_mini_program_secret: '',
    });

    // 商户信息表单
    const merchantForm = reactive({
      wechat_merchant_id: '',
      wechat_merchant_name: '',
      wechat_merchant_password: '',

      wechat_api_v2_key: '',
      wechat_api_v3_key: '',
    });

    // 表单验证规则
    const miniProgramRules = {
      wechat_mini_program_appid: [
        { required: true, message: '请输入小程序AppID', trigger: 'blur' },
      ],
      wechat_mini_program_secret: [
        { required: true, message: '请输入小程序密钥', trigger: 'blur' },
      ],
    };

    const merchantRules = {
      wechat_merchant_id: [
        { required: true, message: '请输入微信商户号', trigger: 'blur' },
      ],
      wechat_merchant_name: [
        { required: true, message: '请输入商户名称', trigger: 'blur' },
      ],
    };

    // 系统管理/设置/微信配置的字段映射 key -> description
    const SETTING_KEYS = {
      // 小程序
      wechat_mini_program_appid: { type: 'string', description: '小程序AppID' },
      wechat_mini_program_secret: { type: 'string', description: '小程序密钥' },
      // 商户
      wechat_merchant_id: { type: 'string', description: '微信商户号' },
      wechat_merchant_name: { type: 'string', description: '商户名称' },
      wechat_merchant_password: { type: 'string', description: '商户操作密码' },

      wechat_api_v2_key: { type: 'string', description: 'APIv2密钥' },
      wechat_api_v3_key: { type: 'string', description: 'APIv3密钥' },
    };

    // 获取系统管理/设置/微信配置
    const fetchSettings = async () => {
      try {
        const res = await getWechatSettings();
        if (res.code === 200) {
          const data = res.data || {};
          // 填充表单
          miniProgramForm.wechat_mini_program_appid = data.wechat_mini_program_appid || '';
          miniProgramForm.wechat_mini_program_secret = data.wechat_mini_program_secret || '';
          merchantForm.wechat_merchant_id = data.wechat_merchant_id || '';
          merchantForm.wechat_merchant_name = data.wechat_merchant_name || '';
          merchantForm.wechat_merchant_password = data.wechat_merchant_password || '';

          merchantForm.wechat_api_v2_key = data.wechat_api_v2_key || '';
          merchantForm.wechat_api_v3_key = data.wechat_api_v3_key || '';
        }
      } catch (error) {
        console.error('获取系统管理/设置/微信配置失败:', error);
        ElMessage.error('获取系统管理/设置/微信配置失败');
      }
    };

    // 保存小程序信息
    const handleMiniProgramSave = () => {
      if (!miniProgramFormRef.value) return;
      miniProgramFormRef.value.validate(async (valid) => {
        if (!valid) return;

        try {
          const settings = {};
          for (const key of ['wechat_mini_program_appid', 'wechat_mini_program_secret']) {
            settings[key] = {
              value: miniProgramForm[key],
              type: SETTING_KEYS[key].type,
              description: SETTING_KEYS[key].description,
            };
          }
          const res = await saveWechatSettings(settings);
          if (res.code === 200) {
            ElMessage.success('小程序信息保存成功');
          }
        } catch (error) {
          console.error('保存小程序信息失败:', error);
          ElMessage.error('保存失败');
        }
      });
    };

    // 重置小程序信息
    const handleMiniProgramReset = () => {
      miniProgramForm.wechat_mini_program_appid = '';
      miniProgramForm.wechat_mini_program_secret = '';
    };

    // 保存商户信息
    const handleMerchantSave = () => {
      if (!merchantFormRef.value) return;
      merchantFormRef.value.validate(async (valid) => {
        if (!valid) return;

        try {
          const merchantKeys = [
            'wechat_merchant_id',
            'wechat_merchant_name',
            'wechat_merchant_password',

            'wechat_api_v2_key',
            'wechat_api_v3_key',
          ];
          const settings = {};
          for (const key of merchantKeys) {
            settings[key] = {
              value: merchantForm[key],
              type: SETTING_KEYS[key].type,
              description: SETTING_KEYS[key].description,
            };
          }
          const res = await saveWechatSettings(settings);
          if (res.code === 200) {
            ElMessage.success('商户信息保存成功');
          }
        } catch (error) {
          console.error('保存商户信息失败:', error);
          ElMessage.error('保存失败');
        }
      });
    };

    // 重置商户信息
    const handleMerchantReset = () => {
      merchantForm.wechat_merchant_id = '';
      merchantForm.wechat_merchant_name = '';
      merchantForm.wechat_merchant_password = '';

      merchantForm.wechat_api_v2_key = '';
      merchantForm.wechat_api_v3_key = '';
    };

    onMounted(() => {
      fetchSettings();
    });

    return {
      activeTab,
      miniProgramFormRef,
      merchantFormRef,
      miniProgramForm,
      merchantForm,
      miniProgramRules,
      merchantRules,
      handleMiniProgramSave,
      handleMiniProgramReset,
      handleMerchantSave,
      handleMerchantReset,
    };
  },
};
</script>

<style scoped>




.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}
</style>
